export default "__VITE_ASSET___Ndv2G7o__"